import { ReactNode } from 'react';
import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { ErrorStatePageError } from 'ui/illustrations';

const StyledEmptyState = styled(EmptyState)`
  height: 100%;
  justify-content: center;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

type TakeoverBodyProps = {
  hasError: boolean;
  id: string;
  /** A targetable name for the embedded browsing context that can be used in the `target` attribute of links */
  name?: string;
  /** label given to iframe to label it's content for assistive technologies */
  title?: string;
  /** text provided in the empty state in case of errors */
  errorSubtitle: ReactNode;
  /** text provided in the empty state in case of errors */
  errorTitle: string;
  /** url used in the `src` attribute of an `iframe` */
  url: string | undefined;
};

export const TakeoverBody = ({
  errorSubtitle,
  errorTitle,
  hasError,
  id,
  name,
  title,
  url,
}: TakeoverBodyProps) => {
  if (hasError || !url) {
    return (
      <StyledEmptyState
        data-test={`${id}-error`}
        Illustration={ErrorStatePageError}
        subtitle={errorSubtitle}
        title={errorTitle}
      />
    );
  }

  return <StyledIframe data-test={`${id}-iframe`} name={name} src={url} title={title} />;
};
